{
  "source": "EA Sports FC 26 (fcratings.com) + identification des titulaires (sofascore.com, beIN Sports, mai-juin 2026)",
  "consultedAt": "2026-06-13",
  "metric": "EA FC 26 overall",
  "note": "Qualité des gardiens titulaires par équipe — métrique uniforme : note globale EA Sports FC 26 (fcratings.com, liste officielle des gardiens, consultée le 13/06/2026). Identification du titulaire croisée avec sofascore.com et beIN Sports (articles « goalkeepers to watch » mai 2026). Couverture partielle assumée : toute équipe absente de ce fichier => séance de tirs au but simulée à 50/50 (défaut scientifique, études UEFA 2025). Fichier complétable au fil du tournoi.",
  "ratings": {
    "BEL": {
      "rating": 90,
      "player": "Thibaut Courtois"
    },
    "BRA": {
      "rating": 88,
      "player": "Alisson"
    },
    "FRA": {
      "rating": 87,
      "player": "Mike Maignan"
    },
    "SUI": {
      "rating": 86,
      "player": "Yann Sommer"
    },
    "ARG": {
      "rating": 85,
      "player": "Emiliano Martínez"
    },
    "ENG": {
      "rating": 85,
      "player": "Jordan Pickford"
    },
    "ESP": {
      "rating": 84,
      "player": "Unai Simón"
    },
    "POR": {
      "rating": 84,
      "player": "Diogo Costa"
    },
    "GER": {
      "rating": 82,
      "player": "Manuel Neuer"
    },
    "MAR": {
      "rating": 82,
      "player": "Yassine Bounou"
    },
    "SEN": {
      "rating": 81,
      "player": "Édouard Mendy"
    },
    "TUR": {
      "rating": 80,
      "player": "Uğurcan Çakır"
    },
    "NED": {
      "rating": 80,
      "player": "Bart Verbruggen"
    }
  }
}
